<template>
  <div>
    <transition name="accordion" @before-enter="beforeEnter" @enter="enter" @leave="leave">
      <div v-if="expandedInternal" ref="panel" class="search-container p-3" style="background-color: #f8f9fa;">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
import { ref, watch, onMounted, nextTick, getCurrentInstance } from 'vue';

export default {
  props: {
    modelValue: {
      type: Boolean,
      default: true
    },
    getTableElement: {
      type: Function,
      default: null
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const instance = getCurrentInstance();
    const expandedInternal = ref(props.modelValue);

    watch(() => props.modelValue, (val) => {
      expandedInternal.value = val;
    });

    watch(expandedInternal, (val) => {
      emit('update:modelValue', val);
    });

    const adjustTableHeight = () => {
      const tableEl = (props.getTableElement && props.getTableElement()) || instance?.proxy?.$parent?.$refs?.tableWrapper;
      if (!tableEl) return;

      const footer = document.querySelector('.app-footer');
      const tableTop = tableEl.getBoundingClientRect().top;
      const footerTop = footer ? footer.getBoundingClientRect().top : window.innerHeight;
      const margin = 16;
      const newMaxHeight = footerTop - tableTop - margin;

      if (newMaxHeight < 100) {
        tableEl.style.maxHeight = '100px';
      } else {
        tableEl.style.maxHeight = `${newMaxHeight}px`;
      }
    };

    watch(expandedInternal, () => {
      nextTick(() => {
        adjustTableHeight();
        setTimeout(() => adjustTableHeight(), 500);
      });
    });

    onMounted(() => {
      window.addEventListener('resize', adjustTableHeight);
      nextTick(() => {
        setTimeout(() => {
          adjustTableHeight();
        }, 100);
      });
    });

    const beforeEnter = (el) => {
      el.style.height = '0';
    };

    const enter = (el) => {
      el.style.transition = 'height 0.3s ease';
      requestAnimationFrame(() => {
        el.style.height = `${el.scrollHeight}px`;
      });
    };

    const leave = (el) => {
      el.style.transition = 'height 0.3s ease';
      el.style.height = `${el.scrollHeight}px`;
      requestAnimationFrame(() => {
        el.style.height = '0';
      });
    };

    return {
      expandedInternal,
      beforeEnter,
      enter,
      leave
    };
  }
};
</script>

<style scoped>
.accordion-enter-active,
.accordion-leave-active {
  overflow: hidden;
  transition: height 0.3s ease;
}
</style>
